module.exports = __webpack_public_path__ + "static/images/0d0e3e4fb1c403b0f8c2d407d8b7ac27.png";